import React from 'react';

/**
 * Full-viewport centered spinner shown while the SPA is bouncing the user to
 * another origin — typically sign-in on the Next.js SEO site after logout or
 * when an unauthenticated user hits a protected route. Replaces the blank
 * `return null` flash during `window.location.replace()`.
 */
export default function AuthBounceSpinner() {
    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#ffffff',
        }}>
            <style>{`@keyframes auth-bounce-spin { to { transform: rotate(360deg); } }`}</style>
            <div
                aria-label="Loading"
                style={{
                    width: 44,
                    height: 44,
                    border: '3px solid #e5e7eb',
                    borderTopColor: '#111827',
                    borderRadius: '50%',
                    animation: 'auth-bounce-spin 0.8s linear infinite',
                }}
            />
        </div>
    );
}
